import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 760px;
`;


export const ContainerInterno = styled.div`
  display: flex;
  flex: 1;
  max-width: 100%;
  flex-direction: column;
  padding-right: 10px;
  padding-left: 10px;
`;

export const ContainerInternoCheck = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
`;
